import React from "react";
import { Link } from 'react-router-dom'
function About() {
        return(
         <div>
            <br/><br/><br/><br/><br/>
     <div className="container-fluid">
        <div id="about" className="row about-section">
            <div className="col-lg-4 about-card">
                <h3 className="font-weight-light">Who am I ?</h3>
                <span className="line mb-5"></span>
                <h5 className="mb-3">A Web Designer / Developer Located In Our Lovely Earth</h5>
                <p className="mt-20">Highly motivated and ambitious undergraduate student with a strong foundation in computer
     applications and a passion for designing and developing websites. Skilled is problem-solving,
     communication, and smart working, with a curious mindset that drives continuous learning.
     Possess expertise in website design and development, including proficiency in React JS.
     Achieved a diploma in computer application and currently pursuing for great programming
     career . Aspiring to become a whitehat hacker to contribute to cybersecurity and safeguard
     digital environments. Known for being curious and possessing exceptional problem-solving
     abilities. Committed to delivering innovative solutions that enhance user experiences and
     meet client objectives.
     </p>

         <Link to="https://app.enhancv.com/share/a2bbd066/?utm_medium=growth&utm_campaign=share-resume&utm_source=dynamic">  <input type="button" value="RESUME"/> </Link>
            </div>
            <div className="col-lg-4 about-card">
                <h3 className="font-weight-light">Personal Info</h3>
                <span className="line mb-5"></span>
                <ul className="mt40 info list-unstyled">
                    <li><span>Birthdate</span> : 24/06/2003</li>
                    <li><span>Email</span> : chetankumayu2003@gmail.com</li>
                    <li><span>Phone</span> : + 8770417166</li>
                    <li><span>Skype</span> : chetan kumayu </li>
                    <li><span>Address</span> :  /32 KODERIYA MHOW INDORE (MP)</li>
                </ul>
                <ul className="social-icons pt-3">
                <li className="social-item"><Link className="social-link text-light" to="https://www.facebook.com/profile.php?id=100089544867955"><i className="ti-facebook" aria-hidden="true"></i></Link></li>
                <li className="social-item"><Link className="social-link text-light" to="https://twitter.com/chetan_kumayu?t=37XDQMfRsc-AQ0Eh0Gx7YA&s=09"><i className="ti-twitter" aria-hidden="true"></i></Link></li>
                <li className="social-item"><Link className="social-link text-light" to="#"><i className="ti-google" aria-hidden="true"></i></Link></li>
                <li className="social-item"><Link className="social-link text-light" to="https://instagram.com/24_chetan_kumayu?igshid=YmMyMTA2M2Y="><i className="ti-instagram" aria-hidden="true"></i></Link></li>
                <li className="social-item"><Link className="social-link text-light" to="#"><i className="ti-github" aria-hidden="true"></i></Link></li>
                </ul>  
            </div>
            <div className="col-lg-4 about-card">
                <h3 className="font-weight-light">My Expertise</h3>
                <span className="line mb-5"></span>
                <div className="row">
                    <div className="col-1 text-danger pt-1"><i className="ti-widget icon-lg"></i></div>
                    <div className="col-10 ml-auto mr-3">
                        <h6>UI/GUI Design</h6>
                        <p className="subtitle"> exercitat Repellendus,  corrupt.</p>
                        <hr/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-1 text-danger pt-1"><i className="ti-paint-bucket icon-lg"></i></div>
                    <div className="col-10 ml-auto mr-3">
                        <h6>Web Development</h6>
                        <p className="subtitle">Lorem ipsum dolor sit consectetur.</p>
                        <hr/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-1 text-danger pt-1"><i className="ti-stats-up icon-lg"></i></div>
                    <div className="col-10 ml-auto mr-3">
                        <h6>Graphic Design</h6>
                        <p className="subtitle">voluptate commodi illo voluptatib.</p>
                        <hr/>
                    </div>
                </div>
            </div>
        </div>
    </div>
        </div>)
    }

export default About